import * as zod from 'zod';

export default zod.object({
  status: zod.enum(['idle', 'running', 'completed', 'failed']).default('idle'),
});
